// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.scss */
:root {
  --foreground-rgb: 0, 0, 0;
  --background-start-rgb: 214, 219, 220;
  --background-end-rgb: 255, 255, 255;
}

.row {
  --bs-gutter-x: 0 !important;
}

.inputBox {
  border: 1px solid rgba(195, 185, 185, 0.568627451);
  box-shadow: 0px 0px 0px 0px #ddd8d8 !important;
  padding: 10px;
  cursor: pointer;
}

.dropdownOption {
  margin-left: -32px;
}

.parentComboboxCSS .bg-indigo-600 {
  --tw-bg-opacity: 1;
  background-color: #d2d2d2;
}

.commRightPadding {
  padding: 0px 10px 0px 0px !important;
}

.commLeftRightPadding {
  padding: 0px 14px 0px 14px !important;
}

.commTopButtonPadding {
  padding: 10px 0px 10px 0px !important;
}

.commTopButtonRightLeftPadding {
  padding: 6px 14px !important;
}

.errorMsg {
  padding: 8px;
  font-size: 14px;
  color: #ff0000 !important;
  font-weight: 600;
}

.successMsg {
  padding: 8px;
  font-size: 16px;
  color: #528b03 !important;
  font-weight: 600;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  /* Semi-transparent background */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  /* Ensure it appears on top */
}

.modal-90w {
  max-width: none !important;
  width: 90% !important;
}

.modal-80w {
  max-width: none !important;
  width: 80% !important;
}

.modal-70w {
  max-width: none !important;
  width: 70% !important;
}

.modal-60w {
  max-width: none !important;
  width: 60% !important;
}

.modal-50w {
  max-width: none !important;
  width: 50% !important;
}

.modal-dialog {
  /* Activity */
}
.modal-dialog .modal-header {
  background-color: var(--modal-header-color);
  color: var(--modal-header-text-color);
  padding: 6px 12px;
  border-radius: 0px;
}
.modal-dialog .modal-header .btn-close {
  background: transparent !important;
  color: var(--modal-header-text-color);
  font-family: "bootstrap-icons";
  font-size: 24px;
  margin-bottom: 4px;
  opacity: 1;
  padding: 0px 6px 0px 0px;
}
.modal-dialog .modal-header .btn-close:focus {
  box-shadow: none;
}
.modal-dialog .modal-header .btn-close::before {
  content: "\\f659";
}
.modal-dialog .modal-header .btn-close:hover {
  color: var(--modal-header-text-color) !important;
}
.modal-dialog .modal-title {
  font-size: 20px;
}
.modal-dialog .modal-title span {
  color: #fff;
  padding-bottom: 12px;
}
.modal-dialog .modal-title i {
  color: var(--modal-header-icon-color);
  font-size: 26px;
  padding-right: 12px;
}
.modal-dialog .subText {
  font-size: 14px !important;
  font-weight: 400 !important;
  margin: 0px !important;
}
.modal-dialog .iconSize {
  font-size: 130px;
}
.modal-dialog .uploadPhoto {
  font-size: 14px;
  color: rgb(82, 82, 240);
  cursor: pointer;
  margin-top: 10px;
}
.modal-dialog .uploadBackground {
  background-color: #f1eeee;
  border-radius: 10px;
}
.modal-dialog .companyImageCss {
  height: 250px !important;
  border: 1px solid #e1dcdc;
}
.modal-dialog .addCardIcon {
  font-size: 35px;
}
.modal-dialog .cardDisplay {
  font-weight: bold;
  margin: 0px;
  margin-top: 10px;
}
.modal-dialog .cardDiv {
  margin-top: 20px;
}
.modal-dialog .cRLoBa {
  width: 80%;
}
.modal-dialog input#cardNumber {
  width: 25em !important;
}
.modal-dialog [type=text]:focus,
.modal-dialog input:where(:not([type])):focus,
.modal-dialog [type=email]:focus,
.modal-dialog [type=url]:focus,
.modal-dialog [type=password]:focus,
.modal-dialog [type=number]:focus,
.modal-dialog [type=date]:focus,
.modal-dialog [type=datetime-local]:focus,
.modal-dialog [type=month]:focus,
.modal-dialog [type=search]:focus,
.modal-dialog [type=tel]:focus,
.modal-dialog [type=time]:focus,
.modal-dialog [type=week]:focus,
.modal-dialog [multiple]:focus,
.modal-dialog textarea:focus,
.modal-dialog select:focus {
  box-shadow: none;
}
.modal-dialog .mapSearchBox {
  background-color: white;
  z-index: 2;
  position: absolute;
  border: 1px solid #bdb9b9;
  border-radius: 5px;
  padding-left: 0px;
  left: 0;
  right: 0;
  width: 94%;
  margin: 0px 0px 0px 26px;
  font-size: 14px;
}
.modal-dialog .mapSearchBox li {
  padding-left: 10px !important;
  line-height: 2;
  border-bottom: 1px solid #eaeaea;
}
.modal-dialog .mapSearchBox li:hover {
  cursor: pointer;
  background-color: #d5d3d3;
}
.modal-dialog .uploadPhoto {
  font-size: 14px;
  cursor: pointer;
}
.modal-dialog .uploadPhoto:hover {
  color: #43465e !important;
  font-weight: 700;
}
.modal-dialog .teamMember {
  margin: 6px 0px;
}
.modal-dialog .teamMember .locationSection {
  align-items: center;
  padding-top: 8px;
  padding-bottom: 8px;
  border: 1px solid #e9e8e8;
  border-radius: 47px;
  padding-left: 10px;
}
.modal-dialog .teamMemersScroll {
  height: auto;
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
.modal-dialog .accordion .accordion-header .bi-chevron-right,
.modal-dialog .accordion .accordion-header .bi-chevron-down {
  font-size: 24px;
  cursor: pointer;
}
.modal-dialog .accordion .accordion-collapse {
  display: none;
  transition: all 0.5s ease-in-out;
}
.modal-dialog .accordion .accordion-collapse.visible {
  display: block;
  transition: all 0.5s ease-in-out;
}
.modal-dialog .filter {
  position: absolute;
  right: 30px;
  top: 15px;
  text-align: end !important;
  width: auto !important;
}
.modal-dialog .dropdown-menu.show {
  position: absolute !important;
  margin: 0 !important;
  transform: translate(0, 0) !important;
}
.modal-dialog .dashboard {
  margin: 0px;
}
.modal-dialog .dashboard .activity {
  font-size: 14px;
}
.modal-dialog .dashboard .activity .activity-item .activite-label {
  color: #888;
  position: relative;
  flex-shrink: 0;
  flex-grow: 0;
  min-width: 120px;
}
.modal-dialog .dashboard .activity .activity-item .activite-label::before {
  content: "";
  position: absolute;
  right: -11px;
  width: 4px;
  top: 0;
  bottom: 0;
  background-color: #eceefe;
}
.modal-dialog .dashboard .activity .activity-item .activity-badge {
  margin-top: -5px;
  z-index: 1;
  font-size: 11px;
  line-height: 0;
  border-radius: 50%;
  flex-shrink: 0;
  border: 3px solid #fff;
  flex-grow: 0;
  margin-left: -4px;
  margin-right: 6px;
  color: var(--modal-header-color);
}
.modal-dialog .dashboard .activity .activity-item .activity-content {
  padding-left: 10px;
  padding-bottom: 20px;
}
.modal-dialog .dashboard .activity .activity-item:first-child .activite-label::before {
  top: 26px;
}
.modal-dialog .dashboard .activity .activity-item:last-child .activity-content {
  padding-bottom: 0;
}
.modal-dialog .headerButtonAlign {
  display: flex;
  justify-content: right;
  flex: 1 1;
}

/* Example CSS */
.my-card-element {
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 4px;
}

.my-card-element-invalid {
  border-color: #ff0000;
}

.navBarHive {
  padding: 0px !important;
  margin: auto !important;
}
.navBarHive .container a {
  text-decoration: none !important;
}
.navBarHive .container .userName {
  text-transform: uppercase;
  font-weight: 700;
}
.navBarHive .container .subMenu {
  font-weight: 400;
  color: #fff !important;
  padding: 16px;
}
.navBarHive .container .subMenu:hover {
  background-color: #374151;
  color: #fff;
  font-weight: 600;
}
.navBarHive .container .userPositionMobile {
  margin-left: 60%;
}
.navBarHive .container .userSection {
  border-top: 1px solid #d5bcbc;
  border-bottom: 1px solid #d5bcbc;
}

/* HeaderWithCard.css */
.header-with-card {
  width: 300px;
}
.header-with-card .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  background-color: #0ccb0c;
}
.header-with-card .arrow {
  transition: transform 0.3s ease;
}
.header-with-card .arrow.down {
  transform: rotate(180deg);
}
.header-with-card .card {
  background-color: #f0f0f0;
  padding: 10px;
  border-radius: 5px;
  margin-top: 10px;
  opacity: 0;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.6s ease, opacity 0.6s ease;
}
.header-with-card .card.visible {
  opacity: 1;
  max-height: 100px;
  /* Adjust as needed */
}

.search-bar {
  min-width: 100%;
  padding: 0px;
}

.search-form {
  width: 100%;
}

.search-form input {
  border: 0;
  font-size: 16px !important;
  padding: 7px 38px 7px 8px;
  border-radius: 3px;
  transition: 0.3s;
  width: 100%;
  border: 1px solid #ccc;
}

.search-form input:focus,
.search-form input:hover {
  outline: none;
  box-shadow: 0 0 10px 0 rgba(1, 41, 112, 0.15);
  border: 1px solid rgba(1, 41, 112, 0.3);
}

.search-form button {
  border: 0;
  padding: 0;
  margin-left: -30px;
  background: none;
}

.search-form button i {
  color: #000000;
}

.dashboard {
  margin-bottom: 30px;
  margin-top: 48px;
}
.dashboard ol,
.dashboard ul {
  padding-left: 0rem;
}
.dashboard a {
  text-decoration: none;
}
.dashboard .leftMenu2 {
  margin-top: 30px;
  padding: 13px 20px 10px 20px;
  text-align: left;
  border: 1px solid #b6b2b2;
  background-color: #fff;
}
.dashboard .leftMenu2 .iconSize {
  font-size: 30px;
}
.dashboard .leftMenu2 .mainTitle {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
  margin-bottom: 10px;
}
.dashboard .leftMenu2 .subText {
  color: #6311ff;
  font-weight: 600;
  margin-bottom: 8px;
}
.dashboard .leftMenu2 .scanQR {
  color: white;
  padding: 6px;
  margin-bottom: 0px;
  text-align: center;
}
.dashboard .leftMenu {
  padding: 14px 36px;
  text-align: left;
  margin: 0px;
  cursor: pointer;
  border-bottom: 1px solid #969696;
}
.dashboard .leftMenu .mainTitle {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
  margin-top: 20px;
}
.dashboard .leftMenu .subText {
  font-size: 13px;
}
.dashboard .leftMenu .iconSize {
  font-size: 44px;
  transition: all 0.3s linear;
}
.dashboard .leftMenu:hover {
  transition: 0.25s;
  transform: scale(0.97);
  background-color: rgba(219, 219, 219, 0.47) !important;
  border-radius: 5px !important;
  border: 1px solid rgba(149, 142, 142, 0.7294117647);
}
.dashboard .rightSide {
  text-align: left;
}
.dashboard .rightSide .mainTitle {
  font-size: 30px;
  font-weight: 600;
}
.dashboard .rightSide .headerButtonAlign {
  display: flex;
  justify-content: right;
  flex: 1 1;
}
.dashboard .rightSide .subText {
  font-size: 16px;
}
.dashboard .rightSide .iconSize {
  font-size: 100px;
}
.dashboard .rightSide .upcomingShift .subText {
  font-size: 18px;
  font-weight: 600;
}
.dashboard .rightSide .upcomingShift .tableStyle {
  border-radius: 5px;
  box-shadow: 0px 0px 2px 0px;
}
.dashboard .rightSide .pastShift .dateTitle {
  font-size: 24px;
  margin-bottom: 12px;
  margin-top: 20px;
  margin-left: 8px;
}
.dashboard .rightSide .pastShiftCard {
  box-shadow: 0px 0px 3px 0px #6d6d6d;
  padding: 8px 0px;
  border-radius: 4px;
  margin: 0px 8px;
  background: #fff;
}
.dashboard .rightSide .pastShiftCard .cardTitle {
  font-size: 20px;
}
.dashboard .rightSide .pastShiftCard .cardDiscriptionTopPro {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0px;
}
.dashboard .rightSide .pastShiftCard .cardDiscriptionTopPro p {
  margin-bottom: 0px;
}
.dashboard .rightSide .pastShiftCard .cardDiscriptionTopPro .topPro {
  color: #00d155;
  font-weight: 600;
  margin-left: 6px;
}
.dashboard .rightSide .pastShiftCard .cardDiscriptionButton {
  display: flex;
  margin-bottom: 0px;
}
.dashboard .rightSide .pastShiftCard .cardDiscriptionButton .imageListMain {
  display: flex;
  margin-bottom: 0px;
}
.dashboard .rightSide .pastShiftCard .cardDiscriptionButton .imageListMain .imageList {
  width: 34px;
  border-radius: 94%;
  height: 30px;
  margin: 0px 0px 0px 6px;
  border: 1px solid #4b4949;
}
.dashboard .rightSide .pastShiftCard .cardDiscription {
  margin-bottom: 0px;
  font-size: 16px;
}
.dashboard .rightSide .pastShiftCard .bookAgain {
  font-size: 18px;
  color: #5959e5;
  margin-bottom: 0px;
  cursor: pointer;
}
.dashboard .rightSide .eventDetails .eventTimeDetails {
  font-size: 16px;
  font-weight: 600;
  margin-left: 6px;
}
.dashboard .rightSide .eventDetails .accordion-header {
  margin-left: 0px;
  margin-right: 0px;
}
.dashboard .rightSide .eventDetails .accordion-item .headerTitle {
  display: block;
  font-size: 16px;
  font-weight: 600;
}
.dashboard .rightSide .eventDetails .accordion-item .subHeaderTitle {
  display: block;
  font-size: 14px;
  font-weight: 400;
}
.dashboard .rightSide .eventDetails .card {
  box-shadow: none;
  border: none;
  background-image: linear-gradient(181deg, #ffffff, #ffffff, #ffffff) !important;
}
.dashboard .rightSide .eventDetails .card-body {
  padding: 2px;
}
.dashboard .rightSide .eventDetails .card-body h5,
.dashboard .rightSide .eventDetails .card-body p {
  margin: 0px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.dashboard .rightSide .eventDetails .card-body:hover {
  cursor: pointer;
  background-color: rgba(244, 243, 243, 0.763);
}
.dashboard .bookshift .lineItem {
  border-radius: 8px;
  padding: 4px 10px;
}
.dashboard .bookshift .lineItem:hover {
  background-color: #e6e6e6;
  border-radius: 8px;
  padding: 4px 10px;
}
.dashboard .bookshift-rightSide {
  text-align: left;
  background-color: rgba(255, 255, 255, 0.5607843137);
  border-radius: 5px;
  border: 1px solid #c9c7c8;
}
.dashboard .bookshift-rightSide .mainTitle {
  font-size: 25px;
  font-weight: 600;
  margin-top: 12px;
}
.dashboard .bookshift-rightSide .subText {
  font-size: 13px;
  margin: 0px;
}
.dashboard .bookshift-rightSide .iconSize {
  font-size: 100px;
}
.dashboard .bookshift-rightSide .loadLocations .card .card-content {
  padding: 8px;
  text-align: left;
  font-size: 12px;
}
.dashboard .bookshift-rightSide .loadLocations .card .card-content .title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
}
.dashboard .bookshift-rightSide .dateTimes {
  /* Basic styles for the card */
  /* Close button styles */
  /* Hover effect for the close button */
}
.dashboard .bookshift-rightSide .dateTimes ul {
  height: 220px;
}
.dashboard .bookshift-rightSide .dateTimes .dropdownOption {
  margin-left: 0px;
  padding-left: 12px;
}
.dashboard .bookshift-rightSide .dateTimes .locationInfo {
  background-color: #eaeae9;
  border-radius: 5px;
  font-size: 18px;
  font-weight: 700;
}
.dashboard .bookshift-rightSide .dateTimes .locationInfo span {
  color: #009c3f !important;
  padding-left: 1%;
}
.dashboard .bookshift-rightSide .dateTimes .card .card-content {
  padding: 8px;
  text-align: left;
  font-size: 12px;
}
.dashboard .bookshift-rightSide .dateTimes .card .card-content .title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
}
.dashboard .bookshift-rightSide .dateTimes .rmdp-day-picker .rmdp-day span {
  border-radius: 34%;
  bottom: 0px;
  font-size: 16px;
  left: 6px;
  position: absolute;
  right: 6px;
  top: 0px;
}
.dashboard .bookshift-rightSide .dateTimes .rmdp-day-picker .rmdp-selected {
  color: #ffffff;
}
.dashboard .bookshift-rightSide .dateTimes .rmdp-day-picker .rmdp-day,
.dashboard .bookshift-rightSide .dateTimes .rmdp-day-picker .rmdp-week-day {
  color: #000;
  cursor: pointer;
  height: 56px;
  position: relative;
  width: 92px;
  margin: 1px;
}
.dashboard .bookshift-rightSide .dateTimes .rmdp-header {
  font-size: 18px;
}
.dashboard .bookshift-rightSide .dateTimes .rmdp-day span {
  font-size: 16px;
}
.dashboard .bookshift-rightSide .dateTimes .rmdp-disabled {
  background-color: #eef2f5;
  border-radius: 50px;
  margin: 1px;
}
.dashboard .bookshift-rightSide .dateTimes .rmdp-container {
  width: 100%;
}
.dashboard .bookshift-rightSide .dateTimes .rmdp-calendar {
  padding-bottom: 54px;
}
.dashboard .bookshift-rightSide .dateTimes .extraCSS {
  position: relative;
  top: -63px;
  left: 11px;
}
.dashboard .bookshift-rightSide .dateTimes .card12 {
  position: relative;
  padding: 10px;
  background-color: #ffffff;
  box-shadow: 0px 0px 4px 0px rgb(74, 73, 73);
  border-radius: 8px;
}
.dashboard .bookshift-rightSide .dateTimes .card12 p {
  margin: 0px;
  padding-right: 32px;
  font-weight: 600;
}
.dashboard .bookshift-rightSide .dateTimes .close-btn {
  position: absolute;
  top: 4px;
  right: 8px;
  cursor: pointer;
  color: #7f7b7b !important;
  font-size: 14px;
  font-weight: 600;
}
.dashboard .bookshift-rightSide .dateTimes .close-btn:hover {
  color: #000000 !important;
  font-weight: 800;
  font-size: 15px;
}
.dashboard .bookshift-rightSide .positions .rowBorder {
  border-bottom: 1px dashed #858484;
}
.dashboard .bookshift-rightSide .positions .cart-item {
  border-bottom: 1px solid #ddd;
  padding: 10px 0;
}
.dashboard .bookshift-rightSide .positions .itemName {
  font-size: 16px;
  font-weight: 700;
}
.dashboard .bookshift-rightSide .positions .textPros {
  font-size: 12px;
  font-weight: 600;
}
.dashboard .bookshift-rightSide .positions .quantity {
  font-size: 18px;
  font-weight: 700;
}
.dashboard .bookshift-rightSide .positions .quantityTextBox {
  padding: 7px !important;
  text-align: center;
  height: 32px;
  margin-left: 6px;
  width: 80%;
  margin-top: -4px;
}
.dashboard .bookshift-rightSide .positions .close-btn {
  font-size: 20px;
  color: #919191;
  cursor: pointer;
}
.dashboard .bookshift-rightSide .positions .close-btn:hover {
  color: #000;
}
.dashboard .bookshift-rightSide .positions .btnPlusMinus {
  background: linear-gradient(359deg, rgba(19, 24, 52, 0.6705882353), #131834, rgba(19, 24, 52, 0.568627451)) !important;
  border-radius: 20px !important;
  border-color: #534e4e !important;
  color: #fff !important;
  height: 30px;
  width: 56%;
}
.dashboard .bookshift-rightSide .positions .btnPlusMinus:hover {
  background: linear-gradient(359deg, rgb(19, 24, 52), rgba(19, 24, 52, 0.6509803922), rgb(19, 24, 52)) !important;
  border-color: #5679a3 !important;
  /* Lighter Blue border */
}
.dashboard .bookshift-rightSide .positions .btnIcon {
  font-size: 20px;
}
.dashboard .bookshift-rightSide .positions .displayDateTime {
  background-color: #ededeb;
  padding: 15px !important;
  border-radius: 5px;
}
.dashboard .bookshift-rightSide .positions .displayDateTime .displayDate {
  font-size: 14px;
  font-weight: 700;
}
.dashboard .bookshift-rightSide .positions .displayDateTime .displayDay {
  font-size: 14px;
  padding-left: 6px;
}
.dashboard .bookshift-rightSide .positions .displayDateTime .displayTime {
  font-weight: 600;
  font-size: 12px;
}
.dashboard .bookshift-rightSide .instructions .cardImgCss {
  height: 100px;
  width: auto;
  margin-top: 6px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.dashboard .bookshift-rightSide .instructions .cardImgCss2 {
  height: 220px;
  width: auto;
  margin-top: 6px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.dashboard .bookshift-rightSide .instructions .cardImgTitle {
  font-size: 12px;
  text-align: center;
  margin-top: 4px;
  font-weight: 500;
}
.dashboard .bookshift-rightSide .instructions .descriptionMainTitle {
  font-size: 20px;
  text-align: center;
  margin-top: 4px;
  font-weight: 600;
  line-height: 2;
}
.dashboard .bookshift-rightSide .instructions .descriptionTitle {
  font-size: 14px;
  text-align: center;
  margin-top: 4px;
  font-weight: 500;
  line-height: 2;
}
.dashboard .bookshift-rightSide .instructions .descriptionValue {
  font-size: 14px;
  text-align: center;
  margin-top: 4px;
  line-height: 2;
}
.dashboard .bookshift-rightSide .instructions .groomingTitle {
  font-size: 14px;
  text-align: center;
  margin-top: 10px;
  font-weight: 500;
}
.dashboard .bookshift-rightSide .instructions .groomingDiscription {
  font-size: 14px;
  font-weight: 500;
  padding-left: 8px;
}
.dashboard .bookshift-rightSide .instructions .onsiteContactsTitle {
  font-size: 15px;
  font-weight: 400;
  padding-left: 8px;
}
.dashboard .bookshift-rightSide .instructions .card-container {
  display: flex;
  flex-wrap: wrap;
}
.dashboard .bookshift-rightSide .instructions .coverTitle {
  font-size: 20px;
  font-weight: 600;
}
.dashboard .bookshift-rightSide .instructions .mainTitle {
  font-size: 25px;
  font-weight: 600;
  margin-top: 12px;
}
.dashboard .bookshift-rightSide .instructions .card {
  border: 1px solid #ebdddd;
  cursor: pointer;
}
.dashboard .bookshift-rightSide .instructions .card:hover {
  border: 1px solid #868686;
}
.dashboard .bookshift-rightSide .instructions .selected {
  position: relative;
}
.dashboard .bookshift-rightSide .instructions .onSelectBorder {
  border: 1px solid #868686;
}
.dashboard .bookshift-rightSide .instructions .check-icon {
  position: absolute;
  top: 0px;
  right: 15px;
  color: #0ccb0c;
  font-size: 20px;
  z-index: 999;
}
.dashboard .bookshift-rightSide .confirm .rowBorder {
  border-bottom: 1px dashed #858484;
}
.dashboard .bookshift-rightSide .confirm .confirmLineItem p {
  margin-top: 0;
  margin-bottom: 0;
}
.dashboard .bookshift-rightSide .confirm .confirmLineItem .rowBorder {
  border-bottom: 1px dashed #858484;
}
.dashboard .bookshift-rightSide .confirm .confirmLineItem .itemName {
  font-size: 16px;
  font-weight: 700;
}
.dashboard .bookshift-rightSide .confirm .confirmLineItem .textPros {
  font-size: 14px;
  font-weight: 600;
}
.dashboard .bookshift-rightSide .confirm .confirmLineItem .infoIcon {
  margin-left: 14px;
  font-size: 18px;
  color: #001171;
}
.dashboard .bookshift-rightSide .confirm .confirmLineItem .totalText {
  font-size: 24px;
  font-weight: bold;
}
.dashboard .bookshift-rightSide .confirm .confirmLineItem .totalAmt {
  font-size: 24px;
  font-weight: 600;
}
.dashboard .bookshift-rightSide .confirm .confirmLineItem .totalDesc {
  font-size: 18px;
  font-weight: 400;
}
.dashboard .button-container {
  display: flex;
}
.dashboard .button-container .left-button {
  margin: 2px;
}
.dashboard .button-container .left-button i {
  font-size: 22px !important;
}
.dashboard .button-container .right-button {
  margin: 2px;
}
.dashboard .button-container .right-button i {
  font-size: 22px !important;
}
.dashboard .homeScreen .info-card h6 {
  font-size: 24px;
}
.dashboard .homeScreen .card {
  cursor: pointer;
}
.dashboard .homeScreen .card:hover {
  background: var(--home-card-hover-color);
}
.dashboard .homeScreen .card:hover h6 {
  color: var(--home-card-text-color);
}
.dashboard .inboxScreen .subTextCard {
  font-size: 16px;
  font-weight: 500;
}
.dashboard .inboxScreen h1 {
  font-size: 50px;
}
.dashboard .inboxScreen .card-icon {
  color: var(--home-card-text-color);
  background: var(--home-card-hover-color);
  font-weight: 600;
  font-size: 32px;
  line-height: 0;
  width: 100px;
  height: 100px;
  flex-shrink: 0;
  flex-grow: 0;
}
.dashboard .inboxScreen .card-body {
  height: 100px;
  padding: 0px;
}
.dashboard .inboxScreen .card-body:hover {
  background: var(--inbox-card-hover-color);
}
.dashboard .inboxScreen .card-body:hover h1 {
  color: var(--inbox-card-text-color);
}
.dashboard .inboxScreen .card-body:hover span {
  color: var(--inbox-card-text-color) !important;
}
.dashboard .inboxScreen .info-card {
  padding-bottom: 0px;
}
.dashboard .inboxScreen .card {
  cursor: pointer;
}

.settings {
  margin-top: 70px;
  margin-bottom: 15px;
}
.settings .leftMenu {
  padding: 20px;
  text-align: left;
  margin: 0px;
  cursor: pointer;
  border-bottom: 1px solid #969696;
}
.settings .leftMenu .mainTitle {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
}
.settings .leftMenu .subText {
  font-size: 13px;
}
.settings .leftMenu .iconSize {
  font-size: 52px;
  transition: all 0.3s linear;
}
.settings .leftMenu:hover {
  transition: 0.25s;
  transform: scale(0.97);
  background-color: rgba(219, 219, 219, 0.47) !important;
  border-radius: 5px !important;
  border: 1px solid rgba(149, 142, 142, 0.7294117647);
}
.settings .rightSide {
  text-align: left;
}
.settings .rightSide .mainTitle {
  font-size: 25px;
  font-weight: 600;
}
.settings .rightSide .subText {
  font-size: 13px;
}
.settings .rightSide .iconSize {
  font-size: 100px;
}
.settings .rightSide .uploadPhoto {
  font-size: 14px;
  cursor: pointer;
}
.settings .rightSide .uploadPhoto:hover {
  color: #43465e !important;
  font-weight: 700;
}
.settings .rightSide .error-message {
  font-size: 16px;
  color: red;
  font-weight: 500;
  margin-bottom: 2%;
}
.settings .rightSide .changePassword {
  font-size: 15px;
  padding-top: 8px;
  color: #5252f0;
  font-weight: 500;
  cursor: pointer;
}
.settings .rightSide .location {
  box-shadow: 0px 0px 4px 0px #6d6d6d;
  padding: 8px 0px;
  margin-top: 4%;
}
.settings .rightSide .location .cardTitle {
  font-size: 17px;
  font-weight: 600;
}
.settings .rightSide .location .cardDiscription {
  font-size: 14px;
}
.settings .rightSide .location .edit {
  margin: 2px;
  font-size: 16px;
  cursor: pointer;
}
.settings .rightSide .location .edit:hover {
  color: #000000;
}
.settings .rightSide .location .members {
  font-size: 14px;
  font-weight: 500;
}
.settings .rightSide .location .imgRowHieght {
  height: 240px !important;
}
.settings .rightSide .hiveImageCss {
  height: 215px !important;
  border: 1px solid #e1dcdc;
}
.settings .rightSide .profileImageCss {
  border: 1px solid #e1dcdc;
  width: 20%;
  border-radius: 50%;
  margin-left: 40%;
  margin-bottom: 2%;
}
.settings .rightSide .companyImageCss {
  border: 1px solid #e1dcdc;
  width: 30%;
  border-radius: 5%;
  margin-left: 36%;
  margin-bottom: 2%;
}
.settings .rightSide .teamMemberProfile {
  height: 80px !important;
  border: 1px solid #e1dcdc;
  width: 50%;
  border-radius: 50%;
  margin-left: 20%;
  margin-top: 4%;
}
.settings .rightSide .teamMember {
  box-shadow: 0px 0px 2px 0px #6d6d6d;
  padding: 8px 0px;
  margin-top: 10px;
}
.settings .rightSide .teamMember .cardPaddinfLeft {
  padding-left: 6px !important;
}
.settings .rightSide .teamMember .subText {
  margin-bottom: 0px;
}
.settings .rightSide .teamMember .cardTitle {
  font-size: 17px;
  font-weight: 600;
}
.settings .rightSide .teamMember .cardDiscription {
  font-size: 14px;
  margin-bottom: 1px;
}
.settings .rightSide .teamMember .edit {
  margin: 2px;
  font-size: 14px;
  font-weight: bold;
}
.settings .rightSide .teamMember .members {
  font-size: 14px;
  font-weight: 500;
}
.settings .rightSide .teamMember .imgRowHieght {
  height: 240px !important;
}
.settings .rightSide .teamMember .iconSizeTeam {
  font-size: 64px;
  color: #57595a;
}
.settings .rightSide .payment .cardlogo {
  height: 30px;
  width: 56px;
  border: 1px solid #e6e4e4;
}
.settings .rightSide .payment .cardDetails {
  display: flex;
}
.settings .rightSide .payment .cardImage {
  margin-bottom: 0px;
}
.settings .rightSide .payment .cardDisplay {
  font-size: 13px;
  letter-spacing: 0.5px;
  margin-top: 4px;
  font-weight: bold;
  margin-bottom: 0px;
}
.settings .rightSide .payment .comDefault {
  font-size: 12px;
  color: #6d6d6d;
  letter-spacing: 0.5px;
  font-weight: bold;
  margin-top: 4px;
  margin-bottom: 0px;
}
.settings .rightSide .payment .card-details {
  padding: 6px 0px;
}

.rivers-timer .timer-box p {
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin-top: 1rem; */
  background: var(--menu-background-color);
  color: var(--app-text-color);
}

/*Create Quotation start */
.createquotation .otherChanges {
  background-color: #5dc371;
  height: 3rem;
  width: 3rem;
  align-items: center;
  display: flex;
  justify-content: center;
  border-radius: 10px;
  color: white;
}

/*Create Quotation end */
/* home-intro start*/
.home-intro .card-icon {
  font-size: 32px;
  line-height: 0;
  width: 54px;
  height: 54px;
  flex-shrink: 0;
  flex-grow: 0;
  margin-right: 14px;
}
.home-intro .headers {
  border-radius: 4px;
  padding: 10px;
  background: #E7F2FF;
}
.home-intro .headers p {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
}
.home-intro .headers span {
  font-size: 24px;
  font-weight: bold;
}
.home-intro .title {
  color: #000;
  font-size: 20px;
  font-weight: 500;
}
.home-intro .date {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.home-intro .date p {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  margin-right: 5px;
}
.home-intro .homeintroposter {
  padding: 10px;
  background: --vensap-background-theme;
  border-radius: 4px;
}
.home-intro .homeintroposter .postertext {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
}
.home-intro .homeintroposter .postertext p {
  color: var(--app-text-color);
  font-size: 40px;
  margin-bottom: 10px;
}
.home-intro .homeintroposter .postertext .smarthub {
  font-size: 40px;
  background-color: #2d324d;
  font-weight: bolder;
  border-radius: 56px;
  margin-bottom: 10px;
  padding: 5px 41px;
  margin: 0px;
}
.home-intro .homeintroposter .postertext .smarthub p:nth-child(1) {
  margin: 0;
  color: #fff;
}
.home-intro .homeintroposter .postertext .smarthub p:nth-child(2) {
  margin: 0;
  color: #fff;
  font-size: 24px;
}
.home-intro .homeintroposter .postertext span {
  color: #fff;
  font-size: 20px;
}

/* home-intro end */
/* homwe-intro-video start */
.video-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.video-container .video-controls {
  margin-top: 10px;
  display: flex;
  align-items: center;
}
.video-container .video-controls button {
  margin: 0 5px;
}
.video-container .video-controls input {
  margin: 0 10px;
}

/* homwe-intro-video end */
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  #main {
    padding: 6px 2px !important;
  }
  .supplier_app {
    font-size: 25px;
  }
  .rightPadding {
    padding-right: 0px !important;
  }
  .leftPadding {
    padding-right: 0px !important;
  }
  .commTopButtonRightLeftPadding {
    padding: 6px 12px !important;
  }
  .commLeftRightPadding {
    padding: 6px 12px !important;
  }
  .dashboard .rightSide .pastShift .dateTitle {
    font-size: 22px;
  }
  .dashboard .rightSide .pastShiftCard .cardTitle {
    font-size: 18px;
  }
  .dashboard .rightSide .pastShiftCard .cardDiscriptionTopPro {
    flex-direction: column;
    font-size: 14px;
  }
  .dashboard .rightSide .pastShiftCard .cardDiscriptionButton {
    flex-direction: column;
  }
  .dashboard .rightSide .pastShiftCard .cardDiscriptionButton p {
    margin-bottom: 6px;
  }
  .dashboard .rightSide .pastShiftCard .cardDiscription {
    font-size: 14px;
  }
  .dashboard .rightSide .pastShiftCard .bookAgain {
    font-size: 14px;
  }
  .settings .rightSide {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
  }
  .settings .rightSide .locationBtn {
    font-size: 12px !important;
  }
  .settings .rightSide .location .cardDiscription {
    font-size: 12px;
  }
  .settings .rightSide .location .imgRowHieght {
    height: 140px !important;
  }
  .settings .rightSide .location .hiveImageCss {
    height: 130px !important;
  }
  .settings .rightSide .teamMember .cardTitle {
    font-size: 14px;
  }
  .settings .rightSide .teamMember .cardDiscription {
    font-size: 12px;
  }
  .settings .rightSide .teamMember .edit {
    font-size: 12px;
  }
  .settings .rightSide .teamMember .iconSizeTeam {
    font-size: 42px;
  }
  .settings .rightSide .teamMember .cardPaddinfLeft {
    padding-left: 0px !important;
  }
  .settings .rightSide .profileImageCss {
    width: 54%;
    border-radius: 50%;
    margin-left: 24%;
  }
  .settings .rightSide .companyImageCss {
    height: 166px !important;
    border: 1px solid #e1dcdc;
    border-radius: 1%;
    margin-bottom: 2%;
    width: 100%;
    margin-left: 0px;
  }
  .settings .rightSide .teamMemberProfile {
    height: 57px !important;
    border: 1px solid #e1dcdc;
    margin: 10%;
    width: 76%;
  }
  .settings .reverseCard {
    flex-direction: column-reverse;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .md-hidden {
    display: none;
  }
  .supplier_app {
    font-size: 34px;
  }
  .rightPadding {
    padding-right: 8px !important;
  }
  .leftPadding {
    padding-right: 8px !important;
  }
}
/* Large devices (laptops/desktops, 992px and up) */
/* Extra large devices (large laptops and desktops, 1200px and up) */
.top-stats-card .card {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
}

.top-stats-card .card .card-body {
  padding: 0 !important;
}

.align-items-stretch .card.h-100 {
  height: 100%;
}

.status-donut-inner {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/dashboard.scss"],"names":[],"mappings":"AACA,gBAAA;AAGA;EACE,yBAAA;EACA,qCAAA;EACA,mCAAA;AADF;;AAIA;EACE,2BAAA;AADF;;AAIA;EACE,kDAAA;EACA,8CAAA;EACA,aAAA;EACA,eAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAQE;EACE,kBAAA;EACA,yBAAA;AALJ;;AASA;EACE,oCAAA;AANF;;AASA;EACE,qCAAA;AANF;;AASA;EACE,qCAAA;AANF;;AASA;EACE,4BAAA;AANF;;AASA;EACE,YAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AANF;;AASA;EACE,YAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AANF;;AASA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,0CAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,6BAAA;AANF;;AA2BA;EACE,0BAAA;EACA,qBAAA;AAxBF;;AA2BA;EACE,0BAAA;EACA,qBAAA;AAxBF;;AA2BA;EACE,0BAAA;EACA,qBAAA;AAxBF;;AA2BA;EACE,0BAAA;EACA,qBAAA;AAxBF;;AA2BA;EACE,0BAAA;EACA,qBAAA;AAxBF;;AA4BA;EA+ME,aAAA;AAvOF;AAyBE;EACE,2CAAA;EACA,qCAAA;EACA,iBAAA;EACA,kBAAA;AAvBJ;AAyBI;EACE,kCAAA;EACA,qCAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,wBAAA;AAvBN;AA0BI;EACE,gBAAA;AAxBN;AA2BI;EACE,gBAAA;AAzBN;AA4BI;EACE,gDAAA;AA1BN;AA8BE;EACE,eAAA;AA5BJ;AA8BI;EACE,WAAA;EACA,oBAAA;AA5BN;AA+BI;EACE,qCAAA;EACA,eAAA;EACA,mBAAA;AA7BN;AAkCE;EACE,0BAAA;EACA,2BAAA;EACA,sBAAA;AAhCJ;AAmCE;EACE,gBAAA;AAjCJ;AAoCE;EACE,eAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAlCJ;AAqCE;EACE,yBAAA;EACA,mBAAA;AAnCJ;AAsCE;EACE,wBAAA;EACA,yBAAA;AApCJ;AAwCE;EACE,eAAA;AAtCJ;AAyCE;EACE,iBAAA;EACA,WAAA;EACA,gBAAA;AAvCJ;AA0CE;EACE,gBAAA;AAxCJ;AA2CE;EACE,UAAA;AAzCJ;AA4CE;EACE,sBAAA;AA1CJ;AA6CE;;;;;;;;;;;;;;;;EAgBE,gBAAA;AA3CJ;AA8CE;EACE,uBAAA;EACA,UAAA;EACA,kBAAA;EAEA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,wBAAA;EACA,eAAA;AA5CJ;AA8CI;EACE,6BAAA;EACA,cAAA;EACA,gCAAA;AA5CN;AA+CI;EACE,eAAA;EACA,yBAAA;AA7CN;AAiDE;EACE,eAAA;EACA,eAAA;AA/CJ;AAkDE;EACE,yBAAA;EACA,gBAAA;AAhDJ;AAmDE;EACE,eAAA;AAjDJ;AAmDI;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AAjDN;AAqDE;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAnDJ;AAyDM;;EAEE,eAAA;EACA,eAAA;AAvDR;AA2DI;EACE,aAAA;EACA,gCAAA;AAzDN;AA4DI;EACE,cAAA;EACA,gCAAA;AA1DN;AA8DE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,0BAAA;EACA,sBAAA;AA5DJ;AA+DE;EACE,6BAAA;EAEA,oBAAA;EACA,qCAAA;AA9DJ;AAkEE;EACE,WAAA;AAhEJ;AAmEE;EACE,eAAA;AAjEJ;AAoEE;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AAlEJ;AAqEE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,yBAAA;AAnEJ;AAsEE;EACE,gBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,gCAAA;AApEJ;AAuEE;EACE,kBAAA;EACA,oBAAA;AArEJ;AAwEE;EACE,SAAA;AAtEJ;AAyEE;EACE,iBAAA;AAvEJ;AA0EE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAxEJ;;AAgFA,gBAAA;AACA;EACE,sBAAA;EACA,aAAA;EACA,kBAAA;AA7EF;;AAgFA;EACE,qBAAA;AA7EF;;AAiFA;EACE,uBAAA;EACA,uBAAA;AA9EF;AAiFI;EACE,gCAAA;AA/EN;AAkFI;EACE,yBAAA;EACA,gBAAA;AAhFN;AAmFI;EACE,gBAAA;EACA,sBAAA;EACA,aAAA;AAjFN;AAoFI;EACE,yBAAA;EACA,WAAA;EACA,gBAAA;AAlFN;AAqFI;EACE,gBAAA;AAnFN;AAsFI;EACE,6BAAA;EACA,gCAAA;AApFN;;AAyFA,uBAAA;AACA;EACE,YAAA;AAtFF;AAwFE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AAtFJ;AAyFE;EACE,+BAAA;AAvFJ;AA0FE;EACE,yBAAA;AAxFJ;AA2FE;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,mDAAA;AAzFJ;AA4FE;EACE,UAAA;EACA,iBAAA;EACA,qBAAA;AA1FJ;;AA+FA;EACE,eAAA;EACA,YAAA;AA5FF;;AA+FA;EACE,WAAA;AA5FF;;AA+FA;EACE,SAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;AA5FF;;AA+FA;;EAEE,aAAA;EACA,6CAAA;EACA,uCAAA;AA5FF;;AA+FA;EACE,SAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;AA5FF;;AA+FA;EACE,cAAA;AA5FF;;AAkGA;EACE,mBAAA;EACA,gBAAA;AA/FF;AAiGE;;EAEE,kBAAA;AA/FJ;AAkGE;EACE,qBAAA;AAhGJ;AAmGE;EACE,gBAAA;EACA,4BAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AAjGJ;AAmGI;EACE,eAAA;AAjGN;AAoGI;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AAlGN;AAqGI;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;AAnGN;AAsGI;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AApGN;AAwGE;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gCAAA;AAtGJ;AAyGI;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAvGN;AA0GI;EACE,eAAA;AAxGN;AA2GI;EACE,eAAA;EACA,2BAAA;AAzGN;AA+GE;EACE,iBAAA;EACA,sBAAA;EACA,sDAAA;EACA,6BAAA;EACA,mDAAA;AA7GJ;AAsHE;EACE,gBAAA;AApHJ;AAsHI;EACE,eAAA;EACA,gBAAA;AApHN;AAuHI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AArHN;AAwHI;EACE,eAAA;AAtHN;AAyHI;EACE,gBAAA;AAvHN;AA4HM;EACE,eAAA;EACA,gBAAA;AA1HR;AA6HM;EAEE,kBAAA;EACA,2BAAA;AA5HR;AAkIM;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAhIR;AAoII;EACE,mCAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAlIN;AAoIM;EACE,eAAA;AAlIR;AAqIM;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;AAnIR;AAqIQ;EACE,kBAAA;AAnIV;AAsIQ;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;AApIV;AAwIM;EACE,aAAA;EACA,kBAAA;AAtIR;AAwIQ;EACE,aAAA;EACA,kBAAA;AAtIV;AAwIU;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,yBAAA;AAtIZ;AA2IM;EACE,kBAAA;EACA,eAAA;AAzIR;AA4IM;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AA1IR;AAiJM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AA/IR;AAkJM;EACE,gBAAA;EACA,iBAAA;AAhJR;AAoJQ;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAlJV;AAqJQ;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAnJV;AAuJM;EACE,gBAAA;EACA,YAAA;EACA,+EAAA;AArJR;AA2JM;EACE,YAAA;AAzJR;AA2JQ;;EAEE,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAzJV;AA6JM;EACE,eAAA;EACA,4CAAA;AA3JR;AAkKI;EAEE,kBAAA;EACA,iBAAA;AAjKN;AAoKI;EACE,yBAAA;EACA,kBAAA;EACA,iBAAA;AAlKN;AAuKE;EACE,gBAAA;EACA,mDAAA;EACA,kBAAA;EACA,yBAAA;AArKJ;AAuKI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AArKN;AAwKI;EACE,eAAA;EACA,WAAA;AAtKN;AAyKI;EACE,gBAAA;AAvKN;AA6KQ;EACE,YAAA;EACA,gBAAA;EACA,eAAA;AA3KV;AA6KU;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AA3KZ;AAsLI;EA4FE,8BAAA;EAiBA,wBAAA;EAWA,sCAAA;AAzSN;AAkLM;EACE,aAAA;AAhLR;AAmLM;EACE,gBAAA;EACA,kBAAA;AAjLR;AAoLM;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAlLR;AAoLQ;EACE,yBAAA;EACA,gBAAA;AAlLV;AAuLQ;EACE,YAAA;EACA,gBAAA;EACA,eAAA;AArLV;AAuLU;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AArLZ;AA6LQ;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AA3LV;AA8LQ;EACE,cAAA;AA5LV;AA+LQ;;EAEE,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;AA7LV;AAiMM;EACE,eAAA;AA/LR;AAkMM;EACE,eAAA;AAhMR;AAmMM;EACE,yBAAA;EACA,mBAAA;EACA,WAAA;AAjMR;AAoMM;EACE,WAAA;AAlMR;AAqMM;EACE,oBAAA;AAnMR;AAsMM;EACE,kBAAA;EACA,UAAA;EACA,UAAA;AApMR;AAwMM;EACE,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,2CAAA;EACA,kBAAA;AAtMR;AAwMQ;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;AAtMV;AA6MM;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AA3MR;AA+MM;EACE,yBAAA;EACA,gBAAA;EACA,eAAA;AA7MR;AAqNM;EACE,iCAAA;AAnNR;AAsNM;EACE,6BAAA;EACA,eAAA;AApNR;AAuNM;EACE,eAAA;EACA,gBAAA;AArNR;AAwNM;EACE,eAAA;EACA,gBAAA;AAtNR;AAyNM;EACE,eAAA;EACA,gBAAA;AAvNR;AA0NM;EACE,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;AAxNR;AA2NM;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAzNR;AA4NM;EACE,WAAA;AA1NR;AA6NM;EACE,sHAAA;EAIA,8BAAA;EACA,gCAAA;EACA,sBAAA;EACA,YAAA;EACA,UAAA;AA9NR;AAiOM;EACE,gHAAA;EAIA,gCAAA;EACA,wBAAA;AAlOR;AAqOM;EACE,eAAA;AAnOR;AAsOM;EACE,yBAAA;EACA,wBAAA;EACA,kBAAA;AApOR;AAsOQ;EACE,eAAA;EACA,gBAAA;AApOV;AAuOQ;EACE,eAAA;EACA,iBAAA;AArOV;AAwOQ;EACE,gBAAA;EACA,eAAA;AAtOV;AA6OM;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AA3OR;AA8OM;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AA5OR;AA+OM;EACE,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AA7OR;AAgPM;EACE,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA9OR;AAiPM;EACE,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA/OR;AAkPM;EACE,eAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAhPR;AAmPM;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAjPR;AAoPM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAlPR;AAqPM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAnPR;AAsPM;EACE,aAAA;EACA,eAAA;AApPR;AAuPM;EACE,eAAA;EACA,gBAAA;AArPR;AAwPM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAtPR;AA6PM;EACE,yBAAA;EACA,eAAA;AA3PR;AA8PM;EACE,yBAAA;AA5PR;AA+PM;EACE,kBAAA;AA7PR;AAgQM;EACE,yBAAA;AA9PR;AAiQM;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;AA/PR;AAqQM;EACE,iCAAA;AAnQR;AAuQQ;EACE,aAAA;EACA,gBAAA;AArQV;AAwQQ;EACE,iCAAA;AAtQV;AAyQQ;EACE,eAAA;EACA,gBAAA;AAvQV;AA0QQ;EACE,eAAA;EACA,gBAAA;AAxQV;AA2QQ;EACE,iBAAA;EACA,eAAA;EACA,cAAA;AAzQV;AA4QQ;EACE,eAAA;EACA,iBAAA;AA1QV;AA6QQ;EACE,eAAA;EACA,gBAAA;AA3QV;AA8QQ;EACE,eAAA;EACA,gBAAA;AA5QV;AAoRE;EACE,aAAA;AAlRJ;AAoRI;EACE,WAAA;AAlRN;AAoRM;EACE,0BAAA;AAlRR;AAsRI;EACE,WAAA;AApRN;AAsRM;EACE,0BAAA;AApRR;AA2RI;EACE,eAAA;AAzRN;AA4RI;EACE,eAAA;AA1RN;AA6RI;EAEE,wCAAA;AA5RN;AA8RM;EACE,kCAAA;AA5RR;AAmSI;EACE,eAAA;EACA,gBAAA;AAjSN;AAoSI;EACE,eAAA;AAlSN;AAqSI;EACE,kCAAA;EACA,wCAAA;EAEA,gBAAA;EAIA,eAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;AA5SN;AA+SI;EACE,aAAA;EACA,YAAA;AArSN;AAwSI;EACE,yCAAA;AAtSN;AAwSM;EACE,mCAAA;AAtSR;AAySM;EACE,8CAAA;AAvSR;AA2SI;EACE,mBAAA;AAzSN;AA4SI;EACE,eAAA;AA1SN;;AAuUA;EACE,gBAAA;EACA,mBAAA;AApUF;AAsUE;EACE,aAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gCAAA;AApUJ;AAsUI;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AApUN;AAuUI;EACE,eAAA;AArUN;AAwUI;EACE,eAAA;EACA,2BAAA;AAtUN;AA4UE;EACE,iBAAA;EACA,sBAAA;EACA,sDAAA;EACA,6BAAA;EACA,mDAAA;AA1UJ;AAmVE;EAEE,gBAAA;AAlVJ;AAuVI;EACE,eAAA;EACA,gBAAA;AArVN;AAwVI;EACE,eAAA;AAtVN;AAyVI;EACE,gBAAA;AAvVN;AA0VI;EACE,eAAA;EACA,eAAA;AAxVN;AA2VI;EACE,yBAAA;EACA,gBAAA;AAzVN;AA4VI;EACE,eAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;AA1VN;AA6VI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AA3VN;AA+VI;EACE,mCAAA;EACA,gBAAA;EACA,cAAA;AA7VN;AA+VM;EACE,eAAA;EACA,gBAAA;AA7VR;AAgWM;EACE,eAAA;AA9VR;AAiWM;EACE,WAAA;EACA,eAAA;EACA,eAAA;AA/VR;AAkWM;EACE,cAAA;AAhWR;AAmWM;EACE,eAAA;EACA,gBAAA;AAjWR;AAoWM;EACE,wBAAA;AAlWR;AAsWI;EACE,wBAAA;EACA,yBAAA;AApWN;AAuWI;EAEE,yBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAtWN;AAyWI;EAEE,yBAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AAxWN;AA2WI;EACE,uBAAA;EACA,yBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAzWN;AA6WI;EACE,mCAAA;EACA,gBAAA;EACA,gBAAA;AA3WN;AA6WM;EACE,4BAAA;AA3WR;AA8WM;EACE,kBAAA;AA5WR;AA+WM;EACE,eAAA;EACA,gBAAA;AA7WR;AAgXM;EACE,eAAA;EACA,kBAAA;AA9WR;AAiXM;EACE,WAAA;EACA,eAAA;EACA,iBAAA;AA/WR;AAkXM;EACE,eAAA;EACA,gBAAA;AAhXR;AAmXM;EACE,wBAAA;AAjXR;AAoXM;EACE,eAAA;EACA,cAAA;AAlXR;AAwXM;EACE,YAAA;EACA,WAAA;EACA,yBAAA;AAtXR;AAyXM;EACE,aAAA;AAvXR;AA0XM;EACE,kBAAA;AAxXR;AA2XM;EACE,eAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAzXR;AA4XM;EACE,eAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AA1XR;AA6XM;EACE,gBAAA;AA3XR;;AAwYI;EACE,aAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,sBAAA;EACA,wCAAA;EACA,4BAAA;AAtYN;;AA6YA,0BAAA;AAEE;EACE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AA3YJ;;AA+YA,wBAAA;AAEA,oBAAA;AAEE;EACE,eAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;AA9YJ;AAiZE;EACE,kBAAA;EACA,aAAA;EAEA,mBAAA;AAhZJ;AAkZI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AAhZN;AAmZI;EACE,eAAA;EACA,iBAAA;AAjZN;AAqZE;EAEE,WAAA;EACA,eAAA;EACA,gBAAA;AApZJ;AAuZE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AArZJ;AAuZI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AArZN;AAyZE;EACE,aAAA;EAEA,qCAAA;EACA,kBAAA;AAxZJ;AA0ZI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;AAxZN;AA0ZM;EACE,4BAAA;EACA,eAAA;EACA,mBAAA;AAxZR;AA2ZM;EAYE,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AApaR;AAmZQ;EACE,SAAA;EACA,WAAA;AAjZV;AAoZQ;EACE,SAAA;EACA,WAAA;EACA,eAAA;AAlZV;AA8ZM;EACE,WAAA;EACA,eAAA;AA5ZR;;AAwaA,mBAAA;AAEA,4BAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAtaF;AAwaE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAtaJ;AAwaI;EACE,aAAA;AAtaN;AAyaI;EACE,cAAA;AAvaN;;AA4aA,0BAAA;AAKA,iDAAA;AACA;EACE;IACE,2BAAA;EA7aF;EAgbA;IACE,eAAA;EA9aF;EAibA;IACE,6BAAA;EA/aF;EAkbA;IACE,6BAAA;EAhbF;EAmbA;IACE,4BAAA;EAjbF;EAobA;IACE,4BAAA;EAlbF;EAqcM;IACE,eAAA;EAncR;EAwcM;IACE,eAAA;EAtcR;EAycM;IACE,sBAAA;IACA,eAAA;EAvcR;EA0cM;IACE,sBAAA;EAxcR;EA0cQ;IACE,kBAAA;EAxcV;EA4cM;IACE,eAAA;EA1cR;EA6cM;IACE,eAAA;EA3cR;EAmdE;IAEE,2BAAA;IACA,8BAAA;EAldJ;EAodI;IACE,0BAAA;EAldN;EAsdM;IACE,eAAA;EApdR;EAudM;IACE,wBAAA;EArdR;EAwdM;IACE,wBAAA;EAtdR;EA2dM;IACE,eAAA;EAzdR;EA4dM;IACE,eAAA;EA1dR;EA6dM;IACE,eAAA;EA3dR;EA8dM;IACE,eAAA;EA5dR;EA+dM;IACE,4BAAA;EA7dR;EAieI;IACE,UAAA;IACA,kBAAA;IACA,gBAAA;EA/dN;EAkeI;IACE,wBAAA;IACA,yBAAA;IACA,iBAAA;IACA,iBAAA;IACA,WAAA;IACA,gBAAA;EAheN;EAmeI;IACE,uBAAA;IACA,yBAAA;IACA,WAAA;IACA,UAAA;EAjeN;EAqeE;IACE,8BAAA;EAneJ;AACF;AAweA,qDAAA;AACA;EACE;IACE,aAAA;EAteF;EAyeA;IACE,eAAA;EAveF;EA0eA;IACE,6BAAA;EAxeF;EA2eA;IACE,6BAAA;EAzeF;AACF;AA4eA,mDAAA;AAGA,oEAAA;AAGA;EACE,kCAAA;EACA,oBAAA;EACA,2BAAA;AA9eF;;AAifA;EACE,qBAAA;AA9eF;;AAifA;EACE,YAAA;AA9eF;;AAifA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AA9eF","sourcesContent":["//Common Code\n/* styles.scss */\n@import './variables.css';\n\n:root {\n  --foreground-rgb: 0, 0, 0;\n  --background-start-rgb: 214, 219, 220;\n  --background-end-rgb: 255, 255, 255;\n}\n\n.row {\n  --bs-gutter-x: 0 !important;\n}\n\n.inputBox {\n  border: 1px solid #c3b9b991;\n  box-shadow: 0px 0px 0px 0px #ddd8d8 !important;\n  padding: 10px;\n  cursor: pointer;\n}\n\n.dropdownOption {\n  margin-left: -32px;\n}\n\n// .dropdownOption:hover {\n//   background-color: #dcdcdc;\n// }\n.parentComboboxCSS {\n  .bg-indigo-600 {\n    --tw-bg-opacity: 1;\n    background-color: #d2d2d2;\n  }\n}\n\n.commRightPadding {\n  padding: 0px 10px 0px 0px !important;\n}\n\n.commLeftRightPadding {\n  padding: 0px 14px 0px 14px !important;\n}\n\n.commTopButtonPadding {\n  padding: 10px 0px 10px 0px !important;\n}\n\n.commTopButtonRightLeftPadding {\n  padding: 6px 14px !important;\n}\n\n.errorMsg {\n  padding: 8px;\n  font-size: 14px;\n  color: #ff0000 !important;\n  font-weight: 600;\n}\n\n.successMsg {\n  padding: 8px;\n  font-size: 16px;\n  color: #528b03 !important;\n  font-weight: 600;\n}\n\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.8);\n  /* Semi-transparent background */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  /* Ensure it appears on top */\n}\n\n// .btn-primary{\n//   padding: 5px;\n//   background-color: #376ed6 !important;\n//   border-color: #2f65cb !important;\n// }\n// .btn-primary:hover{\n//   background-color: #4b82e9 !important;\n// }\n// .btn-outline-primary{\n//   padding: 5px;\n//   border-color: #2f65cb !important;\n// }\n// .btn-outline-primary:hover{\n//   background-color: #4b82e9 !important;\n// }\n\n//add modal\n\n.modal-90w {\n  max-width: none !important;\n  width: 90% !important;\n}\n\n.modal-80w {\n  max-width: none !important;\n  width: 80% !important;\n}\n\n.modal-70w {\n  max-width: none !important;\n  width: 70% !important;\n}\n\n.modal-60w {\n  max-width: none !important;\n  width: 60% !important;\n}\n\n.modal-50w {\n  max-width: none !important;\n  width: 50% !important;\n}\n\n// Modal CSS add herer\n.modal-dialog {\n  .modal-header {\n    background-color: var(--modal-header-color);\n    color: var(--modal-header-text-color);\n    padding: 6px 12px;\n    border-radius: 0px;\n\n    .btn-close {\n      background: transparent !important;\n      color: var(--modal-header-text-color);\n      font-family: 'bootstrap-icons';\n      font-size: 24px;\n      margin-bottom: 4px;\n      opacity: 1;\n      padding: 0px 6px 0px 0px;\n    }\n\n    .btn-close:focus {\n      box-shadow: none;\n    }\n\n    .btn-close::before {\n      content: \"\\f659\";\n    }\n\n    .btn-close:hover {\n      color: var(--modal-header-text-color) !important;\n    }\n  }\n\n  .modal-title {\n    font-size: 20px;\n\n    span {\n      color: #fff;\n      padding-bottom: 12px;\n    }\n\n    i {\n      color: var(--modal-header-icon-color);\n      font-size: 26px;\n      padding-right: 12px;\n    }\n\n  }\n\n  .subText {\n    font-size: 14px !important;\n    font-weight: 400 !important;\n    margin: 0px !important;\n  }\n\n  .iconSize {\n    font-size: 130px;\n  }\n\n  .uploadPhoto {\n    font-size: 14px;\n    color: rgb(82, 82, 240);\n    cursor: pointer;\n    margin-top: 10px;\n  }\n\n  .uploadBackground {\n    background-color: #f1eeee;\n    border-radius: 10px;\n  }\n\n  .companyImageCss {\n    height: 250px !important;\n    border: 1px solid #e1dcdc;\n    // margin-bottom: 2%;\n  }\n\n  .addCardIcon {\n    font-size: 35px;\n  }\n\n  .cardDisplay {\n    font-weight: bold;\n    margin: 0px;\n    margin-top: 10px;\n  }\n\n  .cardDiv {\n    margin-top: 20px;\n  }\n\n  .cRLoBa {\n    width: 80%;\n  }\n\n  input#cardNumber {\n    width: 25em !important;\n  }\n\n  [type=\"text\"]:focus,\n  input:where(:not([type])):focus,\n  [type=\"email\"]:focus,\n  [type=\"url\"]:focus,\n  [type=\"password\"]:focus,\n  [type=\"number\"]:focus,\n  [type=\"date\"]:focus,\n  [type=\"datetime-local\"]:focus,\n  [type=\"month\"]:focus,\n  [type=\"search\"]:focus,\n  [type=\"tel\"]:focus,\n  [type=\"time\"]:focus,\n  [type=\"week\"]:focus,\n  [multiple]:focus,\n  textarea:focus,\n  select:focus {\n    box-shadow: none;\n  }\n\n  .mapSearchBox {\n    background-color: white;\n    z-index: 2;\n    position: absolute;\n    width: 100%;\n    border: 1px solid #bdb9b9;\n    border-radius: 5px;\n    padding-left: 0px;\n    left: 0;\n    right: 0;\n    width: 94%;\n    margin: 0px 0px 0px 26px;\n    font-size: 14px;\n\n    li {\n      padding-left: 10px !important;\n      line-height: 2;\n      border-bottom: 1px solid #eaeaea;\n    }\n\n    li:hover {\n      cursor: pointer;\n      background-color: #d5d3d3;\n    }\n  }\n\n  .uploadPhoto {\n    font-size: 14px;\n    cursor: pointer;\n  }\n\n  .uploadPhoto:hover {\n    color: #43465e !important;\n    font-weight: 700;\n  }\n\n  .teamMember {\n    margin: 6px 0px;\n\n    .locationSection {\n      align-items: center;\n      padding-top: 8px;\n      padding-bottom: 8px;\n      border: 1px solid #e9e8e8;\n      border-radius: 47px;\n      padding-left: 10px;\n    }\n  }\n\n  .teamMemersScroll {\n    height: auto;\n    max-height: 200px;\n    overflow-y: auto;\n    overflow-x: hidden;\n  }\n\n  .accordion {\n    .accordion-header {\n\n      .bi-chevron-right,\n      .bi-chevron-down {\n        font-size: 24px;\n        cursor: pointer;\n      }\n    }\n\n    .accordion-collapse {\n      display: none;\n      transition: all 0.5s ease-in-out;\n    }\n\n    .accordion-collapse.visible {\n      display: block;\n      transition: all 0.5s ease-in-out;\n    }\n  }\n\n  .filter {\n    position: absolute;\n    right: 30px;\n    top: 15px;\n    text-align: end !important;\n    width: auto !important;\n  }\n\n  .dropdown-menu.show {\n    position: absolute !important;\n    // inset: auto auto auto auto !important;\n    margin: 0 !important;\n    transform: translate(0, 0) !important;\n  }\n\n  /* Activity */\n  .dashboard {\n    margin: 0px;\n  }\n\n  .dashboard .activity {\n    font-size: 14px;\n  }\n\n  .dashboard .activity .activity-item .activite-label {\n    color: #888;\n    position: relative;\n    flex-shrink: 0;\n    flex-grow: 0;\n    min-width: 120px;\n  }\n\n  .dashboard .activity .activity-item .activite-label::before {\n    content: \"\";\n    position: absolute;\n    right: -11px;\n    width: 4px;\n    top: 0;\n    bottom: 0;\n    background-color: #eceefe;\n  }\n\n  .dashboard .activity .activity-item .activity-badge {\n    margin-top: -5px;\n    z-index: 1;\n    font-size: 11px;\n    line-height: 0;\n    border-radius: 50%;\n    flex-shrink: 0;\n    border: 3px solid #fff;\n    flex-grow: 0;\n    margin-left: -4px;\n    margin-right: 6px;\n    color: var(--modal-header-color);\n  }\n\n  .dashboard .activity .activity-item .activity-content {\n    padding-left: 10px;\n    padding-bottom: 20px;\n  }\n\n  .dashboard .activity .activity-item:first-child .activite-label::before {\n    top: 26px;\n  }\n\n  .dashboard .activity .activity-item:last-child .activity-content {\n    padding-bottom: 0;\n  }\n\n  .headerButtonAlign {\n    display: flex;\n    justify-content: right;\n    flex: 1;\n  }\n\n\n}\n\n// Modal CSS End\n\n/* Example CSS */\n.my-card-element {\n  border: 1px solid #ccc;\n  padding: 10px;\n  border-radius: 4px;\n}\n\n.my-card-element-invalid {\n  border-color: #ff0000;\n}\n\n//Navbar\n.navBarHive {\n  padding: 0px !important;\n  margin: auto !important;\n\n  .container {\n    a {\n      text-decoration: none !important;\n    }\n\n    .userName {\n      text-transform: uppercase;\n      font-weight: 700;\n    }\n\n    .subMenu {\n      font-weight: 400;\n      color: #fff !important;\n      padding: 16px;\n    }\n\n    .subMenu:hover {\n      background-color: #374151;\n      color: #fff;\n      font-weight: 600;\n    }\n\n    .userPositionMobile {\n      margin-left: 60%;\n    }\n\n    .userSection {\n      border-top: 1px solid #d5bcbc;\n      border-bottom: 1px solid #d5bcbc;\n    }\n  }\n}\n\n/* HeaderWithCard.css */\n.header-with-card {\n  width: 300px;\n\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n    background-color: #0ccb0c;\n  }\n\n  .arrow {\n    transition: transform 0.3s ease;\n  }\n\n  .arrow.down {\n    transform: rotate(180deg);\n  }\n\n  .card {\n    background-color: #f0f0f0;\n    padding: 10px;\n    border-radius: 5px;\n    margin-top: 10px;\n    opacity: 0;\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.6s ease, opacity 0.6s ease;\n  }\n\n  .card.visible {\n    opacity: 1;\n    max-height: 100px;\n    /* Adjust as needed */\n  }\n}\n\n//Common Search Box\n.search-bar {\n  min-width: 100%;\n  padding: 0px;\n}\n\n.search-form {\n  width: 100%;\n}\n\n.search-form input {\n  border: 0;\n  font-size: 16px !important;\n  padding: 7px 38px 7px 8px;\n  border-radius: 3px;\n  transition: 0.3s;\n  width: 100%;\n  border: 1px solid #ccc;\n}\n\n.search-form input:focus,\n.search-form input:hover {\n  outline: none;\n  box-shadow: 0 0 10px 0 rgba(1, 41, 112, 0.15);\n  border: 1px solid rgba(1, 41, 112, 0.3);\n}\n\n.search-form button {\n  border: 0;\n  padding: 0;\n  margin-left: -30px;\n  background: none;\n}\n\n.search-form button i {\n  color: #000000;\n}\n\n//END Common Search Box\n\n//Dashboard\n.dashboard {\n  margin-bottom: 30px;\n  margin-top: 48px;\n\n  ol,\n  ul {\n    padding-left: 0rem;\n  }\n\n  a {\n    text-decoration: none;\n  }\n\n  .leftMenu2 {\n    margin-top: 30px;\n    padding: 13px 20px 10px 20px;\n    text-align: left;\n    border: 1px solid #b6b2b2;\n    background-color: #fff;\n\n    .iconSize {\n      font-size: 30px;\n    }\n\n    .mainTitle {\n      font-size: 16px;\n      font-weight: bold;\n      letter-spacing: 1px;\n      margin-bottom: 10px;\n    }\n\n    .subText {\n      color: #6311ff;\n      font-weight: 600;\n      margin-bottom: 8px;\n    }\n\n    .scanQR {\n      color: white;\n      padding: 6px;\n      margin-bottom: 0px;\n      text-align: center;\n    }\n  }\n\n  .leftMenu {\n    padding: 14px 36px;\n    text-align: left;\n    margin: 0px;\n    cursor: pointer;\n    border-bottom: 1px solid #969696;\n    // background-color: #ffffff;\n\n    .mainTitle {\n      font-size: 16px;\n      font-weight: bold;\n      letter-spacing: 1px;\n      margin-top: 20px;\n    }\n\n    .subText {\n      font-size: 13px;\n    }\n\n    .iconSize {\n      font-size: 44px;\n      transition: all 0.3s linear;\n    }\n  }\n\n  //leftMenu end\n\n  .leftMenu:hover {\n    transition: 0.25s;\n    transform: scale(0.97);\n    background-color: rgb(219 219 219 / 47%) !important;\n    border-radius: 5px !important;\n    border: 1px solid #958e8eba;\n  }\n\n  // .active{\n  //   background-color: rgb(219 219 219 / 47%) !important;\n  //   border-radius: 5px !important;\n  //   border: 1px solid #958e8eba;\n  // }\n\n  .rightSide {\n    text-align: left;\n\n    .mainTitle {\n      font-size: 30px;\n      font-weight: 600;\n    }\n\n    .headerButtonAlign {\n      display: flex;\n      justify-content: right;\n      flex: 1;\n    }\n\n    .subText {\n      font-size: 16px;\n    }\n\n    .iconSize {\n      font-size: 100px;\n    }\n\n    //Upcoming shift\n    .upcomingShift {\n      .subText {\n        font-size: 18px;\n        font-weight: 600;\n      }\n\n      .tableStyle {\n        // border: 1px solid #bdbdbd;\n        border-radius: 5px;\n        box-shadow: 0px 0px 2px 0px;\n      }\n    }\n\n    // Past shift\n    .pastShift {\n      .dateTitle {\n        font-size: 24px;\n        margin-bottom: 12px;\n        margin-top: 20px;\n        margin-left: 8px;\n      }\n    }\n\n    .pastShiftCard {\n      box-shadow: 0px 0px 3px 0px #6d6d6d;\n      padding: 8px 0px;\n      border-radius: 4px;\n      margin: 0px 8px;\n      background: #fff;\n\n      .cardTitle {\n        font-size: 20px;\n      }\n\n      .cardDiscriptionTopPro {\n        display: flex;\n        justify-content: flex-end;\n        margin-bottom: 0px;\n\n        p {\n          margin-bottom: 0px;\n        }\n\n        .topPro {\n          color: #00d155;\n          font-weight: 600;\n          margin-left: 6px;\n        }\n      }\n\n      .cardDiscriptionButton {\n        display: flex;\n        margin-bottom: 0px;\n\n        .imageListMain {\n          display: flex;\n          margin-bottom: 0px;\n\n          .imageList {\n            width: 34px;\n            border-radius: 94%;\n            height: 30px;\n            margin: 0px 0px 0px 6px;\n            border: 1px solid #4b4949;\n          }\n        }\n      }\n\n      .cardDiscription {\n        margin-bottom: 0px;\n        font-size: 16px;\n      }\n\n      .bookAgain {\n        font-size: 18px;\n        color: #5959e5;\n        margin-bottom: 0px;\n        cursor: pointer;\n      }\n    }\n\n\n\n    .eventDetails {\n      .eventTimeDetails {\n        font-size: 16px;\n        font-weight: 600;\n        margin-left: 6px;\n      }\n\n      .accordion-header {\n        margin-left: 0px;\n        margin-right: 0px;\n      }\n\n      .accordion-item {\n        .headerTitle {\n          display: block;\n          font-size: 16px;\n          font-weight: 600;\n        }\n\n        .subHeaderTitle {\n          display: block;\n          font-size: 14px;\n          font-weight: 400;\n        }\n      }\n\n      .card {\n        box-shadow: none;\n        border: none;\n        background-image: linear-gradient(181deg,\n            #ffffff,\n            #ffffff,\n            #ffffff) !important;\n      }\n\n      .card-body {\n        padding: 2px;\n\n        h5,\n        p {\n          margin: 0px;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          overflow: hidden;\n        }\n      }\n\n      .card-body:hover {\n        cursor: pointer;\n        background-color: rgba(244, 243, 243, 0.763);\n      }\n    }\n  }\n\n  // Main Menu\n  .bookshift {\n    .lineItem {\n      // background-color: bisque;\n      border-radius: 8px;\n      padding: 4px 10px;\n    }\n\n    .lineItem:hover {\n      background-color: #e6e6e6;\n      border-radius: 8px;\n      padding: 4px 10px;\n    }\n  }\n\n  // Right side content\n  .bookshift-rightSide {\n    text-align: left;\n    background-color: #ffffff8f;\n    border-radius: 5px;\n    border: 1px solid #c9c7c8;\n\n    .mainTitle {\n      font-size: 25px;\n      font-weight: 600;\n      margin-top: 12px;\n    }\n\n    .subText {\n      font-size: 13px;\n      margin: 0px;\n    }\n\n    .iconSize {\n      font-size: 100px;\n    }\n\n    //1 step\n    .loadLocations {\n      .card {\n        .card-content {\n          padding: 8px;\n          text-align: left;\n          font-size: 12px;\n\n          .title {\n            font-size: 16px;\n            font-weight: 600;\n            margin-bottom: 4px;\n          }\n        }\n      }\n\n      //end card\n    }\n\n    // end loadLocations\n\n    //2 step\n    .dateTimes {\n      ul {\n        height: 220px;\n      }\n\n      .dropdownOption {\n        margin-left: 0px;\n        padding-left: 12px;\n      }\n\n      .locationInfo {\n        background-color: #eaeae9;\n        border-radius: 5px;\n        font-size: 18px;\n        font-weight: 700;\n\n        span {\n          color: #009c3f !important;\n          padding-left: 1%;\n        }\n      }\n\n      .card {\n        .card-content {\n          padding: 8px;\n          text-align: left;\n          font-size: 12px;\n\n          .title {\n            font-size: 16px;\n            font-weight: 600;\n            margin-bottom: 4px;\n          }\n        }\n      }\n\n      //end card\n\n      .rmdp-day-picker {\n        .rmdp-day span {\n          border-radius: 34%;\n          bottom: 0px;\n          font-size: 16px;\n          left: 6px;\n          position: absolute;\n          right: 6px;\n          top: 0px;\n        }\n\n        .rmdp-selected {\n          color: #ffffff;\n        }\n\n        .rmdp-day,\n        .rmdp-week-day {\n          color: #000;\n          cursor: pointer;\n          height: 56px;\n          position: relative;\n          width: 92px;\n          margin: 1px;\n        }\n      }\n\n      .rmdp-header {\n        font-size: 18px;\n      }\n\n      .rmdp-day span {\n        font-size: 16px;\n      }\n\n      .rmdp-disabled {\n        background-color: #eef2f5;\n        border-radius: 50px;\n        margin: 1px;\n      }\n\n      .rmdp-container {\n        width: 100%;\n      }\n\n      .rmdp-calendar {\n        padding-bottom: 54px;\n      }\n\n      .extraCSS {\n        position: relative;\n        top: -63px;\n        left: 11px;\n      }\n\n      /* Basic styles for the card */\n      .card12 {\n        position: relative;\n        padding: 10px;\n        background-color: #ffffff;\n        box-shadow: 0px 0px 4px 0px rgb(74 73 73);\n        border-radius: 8px;\n\n        p {\n          margin: 0px;\n          padding-right: 32px;\n          font-weight: 600;\n        }\n      }\n\n      //end card12\n\n      /* Close button styles */\n      .close-btn {\n        position: absolute;\n        top: 4px;\n        right: 8px;\n        cursor: pointer;\n        color: #7f7b7b !important;\n        font-size: 14px;\n        font-weight: 600;\n      }\n\n      /* Hover effect for the close button */\n      .close-btn:hover {\n        color: #000000 !important;\n        font-weight: 800;\n        font-size: 15px;\n      }\n    }\n\n    // end dateTimes\n\n    //3 Step\n    .positions {\n      .rowBorder {\n        border-bottom: 1px dashed #858484;\n      }\n\n      .cart-item {\n        border-bottom: 1px solid #ddd;\n        padding: 10px 0;\n      }\n\n      .itemName {\n        font-size: 16px;\n        font-weight: 700;\n      }\n\n      .textPros {\n        font-size: 12px;\n        font-weight: 600;\n      }\n\n      .quantity {\n        font-size: 18px;\n        font-weight: 700;\n      }\n\n      .quantityTextBox {\n        padding: 7px !important;\n        text-align: center;\n        height: 32px;\n        margin-left: 6px;\n        width: 80%;\n        margin-top: -4px;\n      }\n\n      .close-btn {\n        font-size: 20px;\n        color: #919191;\n        cursor: pointer;\n      }\n\n      .close-btn:hover {\n        color: #000;\n      }\n\n      .btnPlusMinus {\n        background: linear-gradient(359deg,\n            #131834ab,\n            #131834,\n            #13183491) !important;\n        border-radius: 20px !important;\n        border-color: #534e4e !important;\n        color: #fff !important;\n        height: 30px;\n        width: 56%;\n      }\n\n      .btnPlusMinus:hover {\n        background: linear-gradient(359deg,\n            rgb(19 24 52),\n            #131834a6,\n            rgb(19 24 52)) !important;\n        border-color: #5679a3 !important;\n        /* Lighter Blue border */\n      }\n\n      .btnIcon {\n        font-size: 20px;\n      }\n\n      .displayDateTime {\n        background-color: #ededeb;\n        padding: 15px !important;\n        border-radius: 5px;\n\n        .displayDate {\n          font-size: 14px;\n          font-weight: 700;\n        }\n\n        .displayDay {\n          font-size: 14px;\n          padding-left: 6px;\n        }\n\n        .displayTime {\n          font-weight: 600;\n          font-size: 12px;\n        }\n      }\n    }\n\n    //4 step\n    .instructions {\n      .cardImgCss {\n        height: 100px;\n        width: auto;\n        margin-top: 6px;\n        display: block;\n        margin-left: auto;\n        margin-right: auto;\n      }\n\n      .cardImgCss2 {\n        height: 220px;\n        width: auto;\n        margin-top: 6px;\n        display: block;\n        margin-left: auto;\n        margin-right: auto;\n      }\n\n      .cardImgTitle {\n        font-size: 12px;\n        text-align: center;\n        margin-top: 4px;\n        font-weight: 500;\n      }\n\n      .descriptionMainTitle {\n        font-size: 20px;\n        text-align: center;\n        margin-top: 4px;\n        font-weight: 600;\n        line-height: 2;\n      }\n\n      .descriptionTitle {\n        font-size: 14px;\n        text-align: center;\n        margin-top: 4px;\n        font-weight: 500;\n        line-height: 2;\n      }\n\n      .descriptionValue {\n        font-size: 14px;\n        text-align: center;\n        margin-top: 4px;\n        line-height: 2;\n      }\n\n      .groomingTitle {\n        font-size: 14px;\n        text-align: center;\n        margin-top: 10px;\n        font-weight: 500;\n      }\n\n      .groomingDiscription {\n        font-size: 14px;\n        font-weight: 500;\n        padding-left: 8px;\n      }\n\n      .onsiteContactsTitle {\n        font-size: 15px;\n        font-weight: 400;\n        padding-left: 8px;\n      }\n\n      .card-container {\n        display: flex;\n        flex-wrap: wrap;\n      }\n\n      .coverTitle {\n        font-size: 20px;\n        font-weight: 600;\n      }\n\n      .mainTitle {\n        font-size: 25px;\n        font-weight: 600;\n        margin-top: 12px;\n      }\n\n      // .hrBorder{\n      //   border-top: 1px dashed #868686;\n      // }\n\n      .card {\n        border: 1px solid #ebdddd;\n        cursor: pointer;\n      }\n\n      .card:hover {\n        border: 1px solid #868686;\n      }\n\n      .selected {\n        position: relative;\n      }\n\n      .onSelectBorder {\n        border: 1px solid #868686;\n      }\n\n      .check-icon {\n        position: absolute;\n        top: 0px;\n        right: 15px;\n        color: #0ccb0c;\n        font-size: 20px;\n        z-index: 999;\n      }\n    }\n\n    // 5th step Confirm Page\n    .confirm {\n      .rowBorder {\n        border-bottom: 1px dashed #858484;\n      }\n\n      .confirmLineItem {\n        p {\n          margin-top: 0;\n          margin-bottom: 0;\n        }\n\n        .rowBorder {\n          border-bottom: 1px dashed #858484;\n        }\n\n        .itemName {\n          font-size: 16px;\n          font-weight: 700;\n        }\n\n        .textPros {\n          font-size: 14px;\n          font-weight: 600;\n        }\n\n        .infoIcon {\n          margin-left: 14px;\n          font-size: 18px;\n          color: #001171;\n        }\n\n        .totalText {\n          font-size: 24px;\n          font-weight: bold;\n        }\n\n        .totalAmt {\n          font-size: 24px;\n          font-weight: 600;\n        }\n\n        .totalDesc {\n          font-size: 18px;\n          font-weight: 400;\n        }\n      }\n    }\n  }\n\n  // end bookshift-rightSide\n\n  .button-container {\n    display: flex;\n\n    .left-button {\n      margin: 2px;\n\n      i {\n        font-size: 22px !important;\n      }\n    }\n\n    .right-button {\n      margin: 2px;\n\n      i {\n        font-size: 22px !important;\n      }\n    }\n  }\n\n  //home\n  .homeScreen {\n    .info-card h6 {\n      font-size: 24px;\n    }\n\n    .card {\n      cursor: pointer;\n    }\n\n    .card:hover {\n      // background-image: linear-gradient(181deg, #ffffff, #f3eded, #dbdbdb);\n      background: var(--home-card-hover-color);\n\n      h6 {\n        color: var(--home-card-text-color);\n      }\n    }\n  }\n\n  //inbox\n  .inboxScreen {\n    .subTextCard {\n      font-size: 16px;\n      font-weight: 500;\n    }\n\n    h1 {\n      font-size: 50px;\n    }\n\n    .card-icon {\n      color: var(--home-card-text-color);\n      background: var(--home-card-hover-color);\n      font-size: 40px;\n      font-weight: 600;\n    }\n\n    .card-icon {\n      font-size: 32px;\n      line-height: 0;\n      width: 100px;\n      height: 100px;\n      flex-shrink: 0;\n      flex-grow: 0;\n    }\n\n    .card-body {\n      height: 100px;\n      padding: 0px;\n    }\n\n    .card-body:hover {\n      background: var(--inbox-card-hover-color);\n\n      h1 {\n        color: var(--inbox-card-text-color);\n      }\n\n      span {\n        color: var(--inbox-card-text-color) !important;\n      }\n    }\n\n    .info-card {\n      padding-bottom: 0px;\n    }\n\n    .card {\n      cursor: pointer;\n    }\n  }\n\n  // @media (max-width: 1199px) {\n  //   .search-bar {\n  //     position: fixed;\n  //     top: 50px;\n  //     left: 0;\n  //     right: 0;\n  //     padding: 20px;\n  //     box-shadow: 0px 0px 15px 0px rgba(1, 41, 112, 0.1);\n  //     background: white;\n  //     z-index: 9999;\n  //     transition: 0.3s;\n  //     visibility: hidden;\n  //     opacity: 0;\n  //   }\n  //   .search-bar-show {\n  //     top: 60px;\n  //     visibility: visible;\n  //     opacity: 1;\n  //   }\n  // }\n}\n\n// end dashboard\n\n//Setting\n.settings {\n  margin-top: 70px;\n  margin-bottom: 15px;\n\n  .leftMenu {\n    padding: 20px;\n    text-align: left;\n    margin: 0px;\n    cursor: pointer;\n    border-bottom: 1px solid #969696;\n\n    .mainTitle {\n      font-size: 16px;\n      font-weight: bold;\n      letter-spacing: 1px;\n    }\n\n    .subText {\n      font-size: 13px;\n    }\n\n    .iconSize {\n      font-size: 52px;\n      transition: all 0.3s linear;\n    }\n  }\n\n  //leftMenu end\n\n  .leftMenu:hover {\n    transition: 0.25s;\n    transform: scale(0.97);\n    background-color: rgb(219 219 219 / 47%) !important;\n    border-radius: 5px !important;\n    border: 1px solid #958e8eba;\n  }\n\n  // .active{\n  //   background-color: rgb(219 219 219 / 47%) !important;\n  //   border-radius: 5px !important;\n  //   border: 1px solid #958e8eba;\n  // }\n\n  .rightSide {\n    // border: 1px solid #dfd7d7;\n    text-align: left;\n\n    // .rightSideInner{\n    //   padding: 0px 10px;\n    // }\n    .mainTitle {\n      font-size: 25px;\n      font-weight: 600;\n    }\n\n    .subText {\n      font-size: 13px;\n    }\n\n    .iconSize {\n      font-size: 100px;\n    }\n\n    .uploadPhoto {\n      font-size: 14px;\n      cursor: pointer;\n    }\n\n    .uploadPhoto:hover {\n      color: #43465e !important;\n      font-weight: 700;\n    }\n\n    .error-message {\n      font-size: 16px;\n      color: red;\n      font-weight: 500;\n      margin-bottom: 2%;\n    }\n\n    .changePassword {\n      font-size: 15px;\n      padding-top: 8px;\n      color: #5252f0;\n      font-weight: 500;\n      cursor: pointer;\n    }\n\n    //Location\n    .location {\n      box-shadow: 0px 0px 4px 0px #6d6d6d;\n      padding: 8px 0px;\n      margin-top: 4%;\n\n      .cardTitle {\n        font-size: 17px;\n        font-weight: 600;\n      }\n\n      .cardDiscription {\n        font-size: 14px;\n      }\n\n      .edit {\n        margin: 2px;\n        font-size: 16px;\n        cursor: pointer;\n      }\n\n      .edit:hover {\n        color: #000000;\n      }\n\n      .members {\n        font-size: 14px;\n        font-weight: 500;\n      }\n\n      .imgRowHieght {\n        height: 240px !important;\n      }\n    }\n\n    .hiveImageCss {\n      height: 215px !important;\n      border: 1px solid #e1dcdc;\n    }\n\n    .profileImageCss {\n      // height: 153px !important;\n      border: 1px solid #e1dcdc;\n      width: 20%;\n      border-radius: 50%;\n      margin-left: 40%;\n      margin-bottom: 2%;\n    }\n\n    .companyImageCss {\n      // height: 165px !important;\n      border: 1px solid #e1dcdc;\n      width: 30%;\n      border-radius: 5%;\n      margin-left: 36%;\n      margin-bottom: 2%;\n    }\n\n    .teamMemberProfile {\n      height: 80px !important;\n      border: 1px solid #e1dcdc;\n      width: 50%;\n      border-radius: 50%;\n      margin-left: 20%;\n      margin-top: 4%;\n    }\n\n    //Team Members\n    .teamMember {\n      box-shadow: 0px 0px 2px 0px #6d6d6d;\n      padding: 8px 0px;\n      margin-top: 10px;\n\n      .cardPaddinfLeft {\n        padding-left: 6px !important;\n      }\n\n      .subText {\n        margin-bottom: 0px;\n      }\n\n      .cardTitle {\n        font-size: 17px;\n        font-weight: 600;\n      }\n\n      .cardDiscription {\n        font-size: 14px;\n        margin-bottom: 1px;\n      }\n\n      .edit {\n        margin: 2px;\n        font-size: 14px;\n        font-weight: bold;\n      }\n\n      .members {\n        font-size: 14px;\n        font-weight: 500;\n      }\n\n      .imgRowHieght {\n        height: 240px !important;\n      }\n\n      .iconSizeTeam {\n        font-size: 64px;\n        color: #57595a;\n      }\n    }\n\n    // Payment\n    .payment {\n      .cardlogo {\n        height: 30px;\n        width: 56px;\n        border: 1px solid #e6e4e4;\n      }\n\n      .cardDetails {\n        display: flex;\n      }\n\n      .cardImage {\n        margin-bottom: 0px;\n      }\n\n      .cardDisplay {\n        font-size: 13px;\n        letter-spacing: 0.5px;\n        margin-top: 4px;\n        font-weight: bold;\n        margin-bottom: 0px;\n      }\n\n      .comDefault {\n        font-size: 12px;\n        color: #6d6d6d;\n        letter-spacing: 0.5px;\n        font-weight: bold;\n        margin-top: 4px;\n        margin-bottom: 0px;\n      }\n\n      .card-details {\n        padding: 6px 0px;\n      }\n    }\n  }\n\n  // rightSide end\n}\n\n// Setting end\n\n//rivers-timer\n.rivers-timer {\n  .timer-box {\n    p {\n      width: 2.5rem;\n      height: 2.5rem;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      /* margin-top: 1rem; */\n      background: var(--menu-background-color);\n      color: var(--app-text-color);\n    }\n  }\n}\n\n//rivers-timer end\n\n/*Create Quotation start */\n.createquotation {\n  .otherChanges {\n    background-color: #5dc371;\n    height: 3rem;\n    width: 3rem;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    border-radius: 10px;\n    color: white;\n  }\n}\n\n/*Create Quotation end */\n\n/* home-intro start*/\n.home-intro {\n  .card-icon {\n    font-size: 32px;\n    line-height: 0;\n    width: 54px;\n    height: 54px;\n    flex-shrink: 0;\n    flex-grow: 0;\n    margin-right: 14px;\n  }\n\n  .headers {\n    border-radius: 4px;\n    padding: 10px;\n    // background: linear-gradient(to right, rgb(218, 221, 226) 0%, rgba(255, 255, 255, 0) 100%);\n    background: #E7F2FF;\n\n    p {\n      margin: 0;\n      font-size: 18px;\n      font-weight: 500;\n    }\n\n    span {\n      font-size: 24px;\n      font-weight: bold;\n    }\n  }\n\n  .title {\n    // margin: 0;\n    color: #000;\n    font-size: 20px;\n    font-weight: 500;\n  }\n\n  .date {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n\n    p {\n      margin: 0;\n      font-size: 18px;\n      font-weight: 500;\n      margin-right: 5px;\n    }\n  }\n\n  .homeintroposter {\n    padding: 10px;\n    // background: linear-gradient(to right, rgb(224 230 108) 0%, rgba(255, 255, 255, 0) 100%);\n    background: (--vensap-background-theme);\n    border-radius: 4px;\n\n    .postertext {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      text-align: center;\n      justify-content: center;\n\n      p {\n        color: var(--app-text-color);\n        font-size: 40px;\n        margin-bottom: 10px;\n      }\n\n      .smarthub {\n        p:nth-child(1) {\n          margin: 0;\n          color: #fff;\n        }\n\n        p:nth-child(2) {\n          margin: 0;\n          color: #fff;\n          font-size: 24px;\n        }\n\n        font-size: 40px;\n        background-color: #2d324d;\n        font-weight: bolder;\n        border-radius: 56px;\n        margin-bottom: 10px;\n        padding: 5px 41px;\n        margin: 0px;\n      }\n\n      span {\n        color: #fff;\n        font-size: 20px;\n      }\n\n      // p:nth-child(){\n      //   color:var(--app-text-color);\n      //   font-size: 40px;\n      //   margin-bottom: 10px;\n      // }\n    }\n  }\n}\n\n/* home-intro end */\n\n/* homwe-intro-video start */\n.video-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  .video-controls {\n    margin-top: 10px;\n    display: flex;\n    align-items: center;\n\n    button {\n      margin: 0 5px;\n    }\n\n    input {\n      margin: 0 10px;\n    }\n  }\n}\n\n/* homwe-intro-video end */\n\n// --------------------------------------------------------------------------------------------------- //\n\n// Mobile\n/* Extra small devices (phones, 600px and down) */\n@media only screen and (max-width: 600px) {\n  #main {\n    padding: 6px 2px !important;\n  }\n\n  .supplier_app {\n    font-size: 25px;\n  }\n\n  .rightPadding {\n    padding-right: 0px !important;\n  }\n\n  .leftPadding {\n    padding-right: 0px !important;\n  }\n\n  .commTopButtonRightLeftPadding {\n    padding: 6px 12px !important;\n  }\n\n  .commLeftRightPadding {\n    padding: 6px 12px !important;\n  }\n\n  // .appLandingPage {\n  //   .subContent {\n  //     margin-top: 78% !important;\n  //   }\n  // }\n\n  //Dashboard\n  .dashboard {\n    // .subContent {\n    //   margin-top: -2%;\n    // }\n\n    .rightSide {\n      // margin-left: 0px;\n\n      .pastShift {\n        .dateTitle {\n          font-size: 22px;\n        }\n      }\n\n      .pastShiftCard {\n        .cardTitle {\n          font-size: 18px;\n        }\n\n        .cardDiscriptionTopPro {\n          flex-direction: column;\n          font-size: 14px;\n        }\n\n        .cardDiscriptionButton {\n          flex-direction: column;\n\n          p {\n            margin-bottom: 6px;\n          }\n        }\n\n        .cardDiscription {\n          font-size: 14px;\n        }\n\n        .bookAgain {\n          font-size: 14px;\n        }\n      }\n    }\n  }\n\n  //Settings\n  .settings {\n    .rightSide {\n      // padding: 10px;\n      margin-top: 10px !important;\n      margin-bottom: 10px !important;\n\n      .locationBtn {\n        font-size: 12px !important;\n      }\n\n      .location {\n        .cardDiscription {\n          font-size: 12px;\n        }\n\n        .imgRowHieght {\n          height: 140px !important;\n        }\n\n        .hiveImageCss {\n          height: 130px !important;\n        }\n      }\n\n      .teamMember {\n        .cardTitle {\n          font-size: 14px;\n        }\n\n        .cardDiscription {\n          font-size: 12px;\n        }\n\n        .edit {\n          font-size: 12px;\n        }\n\n        .iconSizeTeam {\n          font-size: 42px;\n        }\n\n        .cardPaddinfLeft {\n          padding-left: 0px !important;\n        }\n      }\n\n      .profileImageCss {\n        width: 54%;\n        border-radius: 50%;\n        margin-left: 24%;\n      }\n\n      .companyImageCss {\n        height: 166px !important;\n        border: 1px solid #e1dcdc;\n        border-radius: 1%;\n        margin-bottom: 2%;\n        width: 100%;\n        margin-left: 0px;\n      }\n\n      .teamMemberProfile {\n        height: 57px !important;\n        border: 1px solid #e1dcdc;\n        margin: 10%;\n        width: 76%;\n      }\n    }\n\n    .reverseCard {\n      flex-direction: column-reverse;\n    }\n  }\n}\n\n// Desktop\n/* Medium devices (landscape tablets, 768px and up) */\n@media only screen and (min-width: 768px) {\n  .md-hidden {\n    display: none;\n  }\n\n  .supplier_app {\n    font-size: 34px;\n  }\n\n  .rightPadding {\n    padding-right: 8px !important;\n  }\n\n  .leftPadding {\n    padding-right: 8px !important;\n  }\n}\n\n/* Large devices (laptops/desktops, 992px and up) */\n@media only screen and (min-width: 992px) {}\n\n/* Extra large devices (large laptops and desktops, 1200px and up) */\n@media only screen and (min-width: 1200px) {}\n\n.top-stats-card .card {\n  background: transparent !important;\n  border: 0 !important;\n  box-shadow: none !important;\n}\n\n.top-stats-card .card .card-body {\n  padding: 0 !important;\n}\n\n.align-items-stretch .card.h-100 {\n  height: 100%;\n}\n\n.status-donut-inner {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
